// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".App_card__1zT54 {\n  margin: 20px;\n}\n.App_mobile__LWcL\\+ {\n  margin: 0px 10px 10px;\n}\n.App_container__Rt8T2.App_card__1zT54 .App_content__wwONY {\n  padding: 0px 30px 30px;\n}\n", "",{"version":3,"sources":["webpack://./src/App.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB","sourcesContent":[".card {\n  margin: 20px;\n}\n.mobile {\n  margin: 0px 10px 10px;\n}\n.container.card .content {\n  padding: 0px 30px 30px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": "App_card__1zT54",
	"mobile": "App_mobile__LWcL+",
	"container": "App_container__Rt8T2",
	"content": "App_content__wwONY"
};
export default ___CSS_LOADER_EXPORT___;
